export default __webpack_public_path__ + "static/media/0xb3b9c016ad1e9f7efdae451b04ef696e05658b32.f32c17d4.webp";